import { useRequest } from 'domain/core/hooks/useRequest';
import { ApiMethodsEnum } from 'infrastructure/enums/ApiMethodsEnum';

export const useGetPublicJobPostById = () => {
  const { data, isLoading, error, send } = useRequest({
    method: ApiMethodsEnum.Get,
    sendOnStart: false,
  });

  const getPublicJobPostById = (id: string) => {
    send({}, `/api/v1/public/job-posts/${id}`).then();
  };

  return {
    getPublicJobPostById,
    data,
    isLoading,
    error,
  };
};
